module.exports = __webpack_public_path__ + "static/media/ranking.82796808.png";